/* eslint-disable no-empty */
/* eslint-disable @typescript-eslint/no-explicit-any */
import {Inject, Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RouterFacadeInterface } from '@ideapa/app-common';
import { BaseDto } from '@ideapa/common-dto';
import { FilterValue } from '@ideapa/common-interfaces';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap/modal';
import { select, Store } from '@ngrx/store';
import {
  ADD_MODE_PARAM,
  EDIT_MODE_PARAM,
  FIND_MODE_PARAM,
  MODAL_LIST_MODE_PARAM,
  VIEW_MODE_PARAM,
} from '../constants';
import { ModalWrapperComponent } from '../modal-wrapper.component';
import * as RouterSelectors from './selectors';

@Injectable({ providedIn: 'root' })
export class RouterFacade implements RouterFacadeInterface {
  isViewOnlyMode$ = this.store.pipe(select(RouterSelectors.isViewOnlyMode));
  isFindMode$ = this.store.pipe(select(RouterSelectors.isFindMode));
  isAddMode$ = this.store.pipe(select(RouterSelectors.isAddMode));
  isEditMode$ = this.store.pipe(select(RouterSelectors.isEditMode));
  isModalListMode$ = this.store.pipe(select(RouterSelectors.isModalListMode));
  channelId$ = this.store.pipe(select(RouterSelectors.channelId));

  constructor(
    private router: Router,
    @Inject(NgbModal) private modalService: NgbModal,
    private store: Store
  ) {}

  /**
   *
   * @param commands
   * @param replaceUrl
   * @param relativeTo null = absolute, undefined = relative to current route
   */
  navigateRelative(
    commands: any[],
    replaceUrl = false,
    relativeTo?: ActivatedRoute | null
  ): void {
    this.router.navigate(commands, {
      relativeTo:
        relativeTo === undefined ? this.getCurrentRoute() : relativeTo,
      queryParamsHandling: 'preserve',
      replaceUrl,
    });
  }

  private getCurrentRoute() {
    let route = this.router.routerState.root;
    while (route.firstChild) {
      route = route.firstChild;
    }

    return route;
  }

  // isAddMode(route?: ActivatedRouteSnapshot) {
  //   route = route ?? this.getCurrentRoute().snapshot;
  //   return !!route.queryParams[ADD_MODE_PARAM];
  // }

  // isModalListMode(route?: ActivatedRouteSnapshot) {
  //   route = route ?? this.getCurrentRoute().snapshot;
  //   return !!route.queryParams[MODAL_LIST_MODE_PARAM];
  // }

  // isViewOnlyMode(route?: ActivatedRouteSnapshot) {
  //   route = route ?? this.getCurrentRoute().snapshot;
  //   return !!route.queryParams[VIEW_MODE_PARAM];
  // }

  // isFindMode(route?: ActivatedRouteSnapshot) {
  //   route = route ?? this.getCurrentRoute().snapshot;
  //   return !!route.queryParams[FIND_MODE_PARAM];
  // }

  // isEditMode(route?: ActivatedRouteSnapshot) {
  //   route = route ?? this.getCurrentRoute().snapshot;
  //   return !!route.queryParams[EDIT_MODE_PARAM];
  // }

  notifySelectedItemToOpener(item: BaseDto, channelId?: string) {
    if (channelId) {
      const bc = new BroadcastChannel(channelId);
      bc.postMessage(item);
    }
  }

  notifyDeletedItemToOpener(id: number, channelId: string) {
    if (channelId) {
      const bc = new BroadcastChannel(channelId);
      bc.postMessage({ id });
    }
  }

  addNewEntity(entity: string, queryParams?: string, customTitle?: string) {
    return this.openModal(ADD_MODE_PARAM, entity, 0, queryParams, customTitle);
  }

  editEntityDetail(
    entity: string,
    id: number,
    queryParams?: string,
    customTitle?: string
  ) {
    return this.openModal(
      EDIT_MODE_PARAM,
      entity,
      id,
      queryParams,
      customTitle
    );
  }

  openEntityDetail(
    entity: string,
    id: number,
    edit: boolean,
    queryParams?: string,
    customTitle?: string
  ) {
    return this.openModal(
      edit ? EDIT_MODE_PARAM : VIEW_MODE_PARAM,
      entity,
      id,
      queryParams,
      customTitle
    );
  }

  searchEntity(
    entity: string,
    filters?: FilterValue[],
    areDomainUserFiltersDisabled?: boolean,
    isEntitySelectionLimited?: boolean,
    areEnteAnnoFiltersDisabled?: boolean
  ) {
    let queryParams = '';

    if (filters) {
      queryParams = queryParams + 'filters=' + btoa(JSON.stringify(filters));
    }

    if (areDomainUserFiltersDisabled) {
      queryParams =
        queryParams +
        '&areDomainUserFiltersDisabled=' +
        btoa(JSON.stringify(areDomainUserFiltersDisabled));
    }

    if (isEntitySelectionLimited) {
      queryParams =
        queryParams +
        '&isEntitySelectionLimited=' +
        btoa(JSON.stringify(isEntitySelectionLimited));
    }

    if (areEnteAnnoFiltersDisabled) {
      queryParams =
        queryParams +
        '&areEnteAnnoFiltersDisabled=' +
        btoa(JSON.stringify(areEnteAnnoFiltersDisabled));
    }

    return this.openModal(FIND_MODE_PARAM, entity, undefined, queryParams);
  }

  openEntityList<T>(
    entity: string,
    param?: T,
    filters?: FilterValue[],
    title?: string,
    fullscreen = false
  ) {
    const filtersQp = filters ? 'filters=' + btoa(JSON.stringify(filters)) : '';

    const entityQp = param ? 'param=' + btoa(JSON.stringify(param)) : '';

    return this.openModal(
      MODAL_LIST_MODE_PARAM,
      entity,
      undefined,
      [filtersQp, entityQp].join('&'),
      title,
      fullscreen ? 'fullscreen-modal' : ''
    );
  }

  async viewEntityDetail(entity: string, id: number, customTitle?: string) {
    try {
      await this.openModal(VIEW_MODE_PARAM, entity, id, undefined, customTitle);
    } catch {}
  }

  private openModal(
    modeParam: string,
    entity: string,
    id?: number,
    queryParams?: string,
    customTitle?: string,
    customClass?: string
  ) {
    // return new Promise<any>((resolve, reject) => {

    const modal = this.modalService.open(ModalWrapperComponent, {
      size: 'xl',
      windowClass: 'iframe-modal',
      backdrop: 'static',
      centered: true,
      modalDialogClass: customClass,
    });

    const modalInstance = modal.componentInstance as ModalWrapperComponent;

    modalInstance.entity = entity;
    modalInstance.queryParams = queryParams;
    modalInstance.id = id;
    modalInstance.mode = modeParam;
    modalInstance.title = customTitle;

    // const w = window.open('_blank');

    return modal.result as Promise<any>;
    // .then((ev) => {
    //   resolve(ev.data);
    // })
    // .catch(() => reject('closed'));

    // if (w == null) {
    //   reject('cannot open popup');
    // } else {
    //   const loop = setInterval(() => {
    //     if (w.closed) {
    //       clearInterval(loop);
    //       bc.close();
    //       reject('closed');
    //     }
    //   }, 500);
    //   const bc = new BroadcastChannel(channelName);
    //   bc.onmessage = (ev) => {
    //     console.log('received msg item added', ev.data);

    //     clearInterval(loop);
    //     w.close();
    //     bc.close();

    //     resolve(ev.data);
    //   };
    // }
    // });
  }
}
